// PostHog product analytics. Project API key from VITE_POSTHOG_KEY at
// build time; empty / missing = no init (PostHog calls become no-ops).
//
// We use posthog-js for browser instrumentation. Identify the Orchestrator on
// sign-in (api/client.saveSession), capture explicit Waytide events
// from feature surfaces (workspace_created, session_connected, etc).

import posthog from "posthog-js";

const KEY = (import.meta.env.VITE_POSTHOG_KEY as string | undefined) ?? "";
const HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ??
  "https://eu.i.posthog.com";
const ENVIRONMENT =
  (import.meta.env.VITE_DEPLOY_ENV as string | undefined) ??
  (import.meta.env.MODE as string | undefined) ??
  "development";

let initialised = false;

export function initPostHog() {
  if (!KEY || initialised) return;
  posthog.init(KEY, {
    api_host: HOST,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    persistence: "localStorage+cookie",
    loaded: (p) => {
      p.register({ environment: ENVIRONMENT });
    },
  });
  initialised = true;
}

export function identifyOrchestrator(identityHex: string, email: string) {
  if (!initialised) return;
  posthog.identify(identityHex, { email });
}

export function resetOrchestrator() {
  if (!initialised) return;
  posthog.reset();
}

export function capture(event: string, properties?: Record<string, unknown>) {
  if (!initialised) return;
  posthog.capture(event, properties);
}
